/**
 * Portal Manta · TipoObraConsol
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S } from '../../globals.js';
import { TIPO_OBRA_MAP } from '../../data/tipo-obra-map.js';
import { M } from '../../tokens/colors.js';

function TipoObraConsol({lote, onFonte}){
  const tip = lote.tipologias||[];
  const totalAmpl = TIPO_OBRA_MAP.reduce((s,t)=>{
    const x = tip.find(y=>y.cod===t.cod); return s + (x?.v||0);
  }, 0);
  const fmt0 = (n)=>(n||0).toLocaleString('pt-BR',{maximumFractionDigits:0});
  const fmt1 = (n)=>(n||0).toLocaleString('pt-BR',{minimumFractionDigits:1,maximumFractionDigits:1});

  return (<div style={{...S.cardP, marginBottom:14, padding:'16px 18px'}}>
    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10}}>
      <div style={{fontSize:12,fontWeight:700,color:V.br}}>Decomposição por tipo de obra de ampliação</div>
      <div style={{fontSize:10,color:V.g4}}>Total ampliação: <strong style={{color:V.or,fontFamily:'monospace'}}>R$ {fmt0(totalAmpl)} M</strong></div>
    </div>
    <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:8}}>
      {TIPO_OBRA_MAP.map(t=>{
        const x = tip.find(y=>y.cod===t.cod);
        const v = x?.v||0;
        const qtd = x?.qtd;
        const pct = totalAmpl>0?(v/totalAmpl*100):0;
        const ru = (qtd!=null && qtd>0) ? v*1e6/qtd : null;
        const fonte = {doc:'Tipologias do edital · MEF',pag:`Aba "Orçamento Paramétrico" linha ${t.cod}`,data:lote.data_base||'—',aut:'ANTT'};
        return (<div key={t.cod} onClick={()=>onFonte({fonte,label:`${t.nome} (${t.cod})`})} style={{padding:'10px 12px',background:'#fff',border:'1px solid '+V.g2,borderRadius:8,cursor:'pointer',transition:'all .12s'}} onMouseEnter={e=>{e.currentTarget.style.borderColor=t.cor;e.currentTarget.style.boxShadow='0 2px 6px rgba(0,0,0,.06)';}} onMouseLeave={e=>{e.currentTarget.style.borderColor=V.g2;e.currentTarget.style.boxShadow='none';}}>
          <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:4}}>
            <div style={{width:8,height:8,borderRadius:2,background:t.cor}}/>
            <div style={{fontSize:9.5,fontWeight:700,color:V.g5,letterSpacing:.2,textTransform:'uppercase'}}>{t.cod}</div>
          </div>
          <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:2}}>{t.nome}</div>
          <div style={{fontSize:14,fontWeight:700,color:t.cor,fontFamily:'monospace'}}>R$ {fmt0(v)} M</div>
          <div style={{fontSize:9.5,color:V.g4,marginTop:2}}>{pct.toFixed(1)}% · {qtd!=null?`${fmt1(qtd)} ${t.un_qtd}`:'—'}</div>
          {ru!=null && <div style={{fontSize:9.5,color:V.g5,marginTop:2,fontFamily:'monospace'}}>R$ {fmt0(ru/1e3)} mil/{t.un_qtd}</div>}
        </div>);
      })}
    </div>
  </div>);
}

export { TipoObraConsol };
export default TipoObraConsol;
